module.exports = __webpack_public_path__ + "static/media/preventivo_amarillo.9c120e58.svg";